<div [ngClass]="'card card-type-'+ type" [class.no-face]="noFace" class="m-0 w-full animate__animated animate__fadeInUp">

  <div class="grid grid-cols-6 items-end">
    <div class="col-span-6 order-1" *ngIf="!noFace">

      <div *ngIf="!image">
        <div *ngIf="type == 'info'">
          <img src="./assets/icons/emojis/01-smile.svg" alt="Emoji Smile" class="w-8 h-8 my-0">
        </div>
  
        <div *ngIf="type == 'clue'">
          <img src="./assets/icons/emojis/07-feeling.svg" alt="Emoji feeling" class="w-8 h-8 my-0">
        </div>
  
        <div *ngIf="type == 'success' || type == 'success'">
          <img src="./assets/icons/emojis/13-love.svg" alt="Emoji love" class="w-8 h-8 my-0">
        </div>
  
        <div *ngIf="type == 'danger'|| type == 'danger'">
          <img src="./assets/icons/emojis/08-sarcastic.svg" alt="Emoji sarcastic" class="w-8 h-8 my-0">
        </div>
      </div>
      <div *ngIf="image">
        <img [src]="image" alt="img" class="w-8 h-8 my-0">
      </div>
    </div>

    <div class="col-span-6 bubble border rounded-lg px-3 py-3 bg-white prose">
      <h2 *ngIf="title" class="mt-0 mb-0 text-base font-semibold card-title">{{ title }}</h2>
      <p *ngIf="description" class="mt-0 mb-0 text-sm">{{ description }}</p>
      <ng-content></ng-content>
      <app-indicator [type]="'score'" [value]="badge" *ngIf="badge && badge != null" class=" bg-white rounded-full border left-auto inline-block text-xs absolute right-4 -top-3"></app-indicator>
    </div>
  </div>
</div>